import { ApplicationSettingsIcon } from './ApplicationSettingsIcon';

/**
 * author: Michael Irigoyen
 * id 0AA8EAC5-6700-47B6-A38B-0E58CFA0CFE7
 * name application-settings
 * version: 3.0.39
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/application-settings.svg
 * tags
 * - Settings 
 */
export const IframeSettingsIcon = ApplicationSettingsIcon;
export default IframeSettingsIcon